import { Outlet, createFileRoute } from '@tanstack/react-router';

import { VStack } from '@/components/Layout';
import { ProductLogoMediumGAOperationCore as LogoGAOperationCore } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';

export const Route = createFileRoute('/_staff/ga-operation-core/_packages')({
  component: GAOperationCoreLayout,
});

function GAOperationCoreLayout() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'pages.gaOperationCore.operationPackages',
  });
  useDocumentTitle(t('gaOperationCore'));

  const tabs: TabWithIndicatorProps[] = [
    {
      to: '/ga-operation-core',
      children: t('tabs.operationPackages'),
      activeOptions: {
        exact: true,
        includeSearch: true,
      },
    },
    {
      to: '/ga-operation-core/archives',
      children: t('tabs.archive'),
      activeOptions: {
        exact: true,
      },
    },
    {
      to: '/ga-operation-core/configs',
      children: t('tabs.config'),
      activeOptions: {
        exact: true,
      },
    },
  ];

  return (
    <VStack>
      <ProductHeader
        Logo={LogoGAOperationCore}
        name={t('gaOperationCore')}
        tabs={tabs}
        type="core"
      />
      <Outlet />
    </VStack>
  );
}
